/**
 * Helper component to create a Link to a specific role-protected page (like "admin")
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

import { Redirect, Route, withRouter } from 'react-router-dom';

import _ from 'lodash';
import omit from 'lodash/omit';

import Auth from '../../utils/auth';
import routeUtils from '../../utils/routeUtils';

class YTRoute extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      breadcrumbs
      , history
      , location
      , login
      , role
    } = this.props;

    let newLocation = location;
    if(!newLocation.state) {
      newLocation.state = {}
    }
    newLocation.state.breadcrumbs = breadcrumbs;
    const props = _.omit(this.props, [
      'location',
    ]);
    if((role || login) && Auth.notLoggedIn()) {
      // additional logic required for sso login
      // if the route is login AND there is an authToken in the query params
      // send to third party login page (which will handle the logic from there)
      // what do we do if they are already logged in??
      const searchObject = routeUtils.objectFromQueryString(location.search);
      // console.log("LOCATION!", location)
      searchObject.redirect = location.pathname;
      // console.log("SEARCH OBJECT", searchObject)
      // console.log("url", `/user/login${routeUtils.queryStringFromObject(searchObject)}`)

      if(searchObject.authToken && searchObject.authToken.length > 0) {
        // NOTE: we will need some additional logic here once we figure out how they are going to setup their redirects and stuff
        // the third url parameter, "acrp", is a variable that should be determined by which provider they are coming from
        return <Redirect to={{pathname: `/user/third-party-login/${searchObject.provider || 'acrp'}`, search: location.search}}/>
      } else if(searchObject.landing) {
        // 1.22 - redirect to b2b portal, if specified
        return <Redirect to={{pathname: `/portal/${searchObject.landing}`, search: routeUtils.queryStringFromObject(searchObject)}}/>
      } else {
        // 1.22 - redirect using query params, so we can support sso redirects
        return <Redirect to={{pathname: `/user/login`, search: routeUtils.queryStringFromObject(searchObject)}}/>
        // return <Redirect to={{pathname: "/user/login", state: { from: location }}}/>
      }
    } else if(role && Auth.notRole(role)) {
      return <Redirect to={{pathname: "/unauthorized"}}/>
    } else {
      return <Route {...props} location={newLocation}  />
    }
  }
}

YTRoute.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      display: PropTypes.string
      , path: PropTypes.string
    })
  )
  , login: PropTypes.bool
  , role: PropTypes.string
}

YTRoute.defaultProps = {
  breadcrumbs: []
  , login: false
  , role: null
}

export default withRouter(YTRoute);



// WEBPACK FOOTER //
// global/components/routing/YTRoute.js.jsx